import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Project from './pages/Project';
import OcrResult from './pages/OcrResult';
import OCRProcessing from './pages/OCRProcessing';
import OCRVerification from './pages/OCRVerification';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import Layout from './components/Layout';
import { useAuth } from './contexts/AuthContext';
import { ThumbnailCacheProvider } from './contexts/ThumbnailCacheContext';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  // 認証状態の読み込み中はローディング表示
  if (isLoading) {
    return <Box>Loading...</Box>;
  }

  return (
    <ThumbnailCacheProvider>
      <Router>
        <Routes>
          {/* 認証不要のルート */}
          <Route path="/login" element={!isAuthenticated ? <Login /> : <Navigate to="/dashboard" />} />
          <Route path="/register" element={!isAuthenticated ? <Register /> : <Navigate to="/dashboard" />} />
        
        {/* 認証が必要なルート */}
        <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route index element={<Navigate to="/dashboard" />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="project/:projectId" element={<Project />} />
          <Route path="project/:projectId/ocr-processing" element={<OCRProcessing />} />
          <Route path="project/:projectId/result/:resultId" element={<OcrResult />} />
          <Route path="verification" element={<OCRVerification />} />

        </Route>
        
        {/* 管理者ルート */}
        <Route path="/admin" element={<AdminProtectedRoute><Layout /></AdminProtectedRoute>}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<AdminDashboard />} />
          <Route path="settings" element={<AdminDashboard />} />
        </Route>
        
        {/* 存在しないルートへのアクセス */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      </Router>
    </ThumbnailCacheProvider>
  );
}

export default App;